import _ from 'lodash';

import config from '../config';
import { questionarySteps } from '../constants/questioner';
import { getLocalStorageObject, setLocalStorageObject, footToFloat } from '../utils/functions';
import { questionerAPI } from '../api/questioner';
import { actionWrapper } from './actionWrapper';

export const SET_STEPS = 'SET_STEPS';
export const SET_MOBILE_STEPS = 'SET_MOBILE_STEPS';
export const NEXT_STEP = 'NEXT_STEP';
export const RESET_STEPS = 'RESET_STEPS';

const STEPS_FIELD_NAME = 'steps';

const getStepsFromLocalStorage = () => {
  return getLocalStorageObject(STEPS_FIELD_NAME);
};

export const getStepsData = () => (dispatch) => {
  const stepsData = getStepsFromLocalStorage();

  // console.log('===INIT stepsData', stepsData);

  if (!_.isEmpty(stepsData)) {
    // stepsData.step = 0;
    dispatch(setStepsData(stepsData));
  }
};

const getStepNumber = (stepsData) => {
  let step = 0;

  questionarySteps.some((fieldData) => {
    if (!_.isEmpty(stepsData[fieldData.field])) {
      step = fieldData.step;
      return true;
    }
  });

  return step;
};

export const getMobileStepsData = () => actionWrapper(async (dispatch) => {
  const stepsData = await questionerAPI.getStepsData();
  const localStorageStepsData = getStepsFromLocalStorage();

  const realNextStep = getStepNumber(stepsData);

  // This is necessary for excluded meals page
  if (!stepsData.excluded_meals && realNextStep > 7) {
    stepsData.excluded_meals = [];
  }



  stepsData.step = typeof localStorageStepsData?.step === 'number' 
    ? localStorageStepsData?.step
    : realNextStep;

  // console.log('===INIT stepsData', stepsData);
  dispatch(setStepsData(stepsData));
});

export const startAgainMobileQuestioner = () => (dispatch, getState) => {
  // console.log('===startAgainMobileQuestioner');
  setLocalStorageObject('generatedMenu', null);
  const stepsData = getState().steps.stepsData;
  stepsData.step = 0;
  dispatch(setStepsData({ ...stepsData }));
};

export const addMobileQuestionerData = (data, callback) =>  actionWrapper(async (dispatch, getState) => {
  let requestData = data;
  
  if (data.allergies) {
    requestData = {
      allergies: _.map(data.allergies, 'id'),
    };
  }
  
  if (data.disliked_products) {
    requestData = {
      disliked_products: _.map(data.disliked_products, 'id'),
    };
  }
  
  await questionerAPI.saveQuestionerData(requestData);

  const stepsData = getState().steps.stepsData;
  Object.assign(stepsData, data);
  stepsData.step++;
  
  // dispatch({
  //   type: SET_MOBILE_STEPS,
  //   payload: data,
  // });
  dispatch(setStepsData({ ...stepsData }));
  callback?.();
});

export const nextStep = () => ({
  type: NEXT_STEP,
});

export const setStepsData = (stepsData) => {
  setLocalStorageObject(STEPS_FIELD_NAME, stepsData);

  return {
    type: SET_STEPS,
    payload: stepsData,
  };
};

const clearSteps = () => {
  localStorage.removeItem(STEPS_FIELD_NAME);
};

const clearStepsWithUpdate = (dispatch) => {
  clearSteps();
  setTimeout(() => {
    dispatch({ type: RESET_STEPS });
  }, config.redirectAfterFinishTime);
};

const prepareQuestionerData = (questionerData) => {
  let { 
    birthDate,
    weightUnit,
    height, 
    heightUnit,
    physicalActivity,
    excludedMeals,
   } = questionerData;

  if (questionerData.heightUnit === 'foot') {
    height = footToFloat(height);
  }

  return {
    ...questionerData,
    birth_date: birthDate,
    weight_unit: weightUnit,
    height,
    height_unit: heightUnit,
    physical_activity: physicalActivity,
    excluded_meals: excludedMeals,
  };
};

export const addQuestioner = (questionerData, callback) => actionWrapper(async (dispatch) => {
  const questionerDataForBack = prepareQuestionerData(questionerData);
  await questionerAPI.addQuestioner(questionerDataForBack);
  clearStepsWithUpdate(dispatch);
  callback?.();
});

export const remindMe = (userData, callback) => actionWrapper(async () => {
  await questionerAPI.remindMe(userData);
  clearSteps();
  callback?.();
});

export const resetSteps = () => {
  return {
    type: RESET_STEPS,
  };
};

export const strictMenu = (questionerData, callback) => actionWrapper(async (dispatch) => {
  const questionerDataForBack = prepareQuestionerData(questionerData);
  await questionerAPI.strictMenu(questionerDataForBack);
  clearStepsWithUpdate(dispatch);
  callback?.();
});

export const changeCountry = (country) => (dispatch, getState) => {
  const stepsData = getState().steps.stepsData;
  stepsData.country = country;
  dispatch(setStepsData(stepsData));
};